import { render, staticRenderFns } from "./LeftChart2.vue?vue&type=template&id=ddd806fa&scoped=true&"
import script from "./LeftChart2.vue?vue&type=script&lang=js&"
export * from "./LeftChart2.vue?vue&type=script&lang=js&"
import style0 from "./LeftChart2.vue?vue&type=style&index=0&id=ddd806fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd806fa",
  null
  
)

export default component.exports